export enum UserEvent {
  app_switch_requested = 'app_switch_requested',
  first_url_app_switch = 'first_url_app_switch',
  onboarding_link_used_web = 'onboarding_link_used_web',
  onboarding_user_agreed_privacy_policy = 'onboarding_user_agreed_privacy_policy',
  onboarding_user_view_privacy_policy = 'onboarding_user_view_privacy_policy',
  onboarding_web_app_button_press = 'onboarding_web_app_button_press',
  onboarding_workbook_button_press = 'onboarding_workbook_button_press',
}
